/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationSubFieldModelSearchResultModel } from '../../models/education-sub-field-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface EducationSubFieldSearchEducationSubFieldPost$Params {
      body?: SearchRequestModel
}

export function educationSubFieldSearchEducationSubFieldPost(http: HttpClient, rootUrl: string, params?: EducationSubFieldSearchEducationSubFieldPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EducationSubFieldModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, educationSubFieldSearchEducationSubFieldPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<EducationSubFieldModelSearchResultModel>;
    })
  );
}

educationSubFieldSearchEducationSubFieldPost.PATH = '/EducationSubField/SearchEducationSubField';
